<template>
  <div>
    <form
      ref="form"
      data-url="/evaluator/evaluationPlan/preparation/referenceDocuments"
      class="mb-0"
      :class="{ 'loading-opacity': preloader }"
    >
      <div class="row">
        <div class="col-md-12">
          <table id="table">
            <thead>
              <tr>
                <th class="a">ANEXO</th>
                <th class="b">NOMBRE DEL DOCUMENTO</th>
                <th class="c">OBSERVACIONES</th>
                <th class="d">SELECCIONAR</th>
              </tr>
            </thead>
            <tbody>
              <evaluation-plan-preparation-reference-documents-item
                v-for="(value, index) in inputs"
                :key="index"
                :index="index"
                :inputs="value"
              />
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mt-3">
          <button type="submit" class="btn btn-primary" @click.prevent="submit">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiURL";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: [],
    };
  },

  created() {
    this.data();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      this.inputs = res.data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;

      this.axiosGet(
        `${actions.EVALUATION_PLAN}/preparation/referenceDocuments?evalTestId=${this.$store.state.evaluatorReview.evalTestId}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.inputs = response.data ? response.data : [];
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
<style lang="css">
#table {
  width: 100%;
}
#table tr {
  border: 1px dotted gray;
}
#table td {
  padding: 0.8rem;
}
#table .a {
  width: 5%;
  text-align: center;
}
#table .b {
  width: 35%;
  text-align: center;
}
#table .c {
  width: 45%;
  text-align: center;
}
#table .d {
  width: 15%;
  text-align: center;
}
</style>